import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { rltBoletimItinerarioWeb } from "../../api-relatorio";
import CircularProgress from '@mui/material/CircularProgress';
import RelatorioBoletimNotaBimestreWeb from "./RelatorioBoletimNotaBimestreWeb";
import RelatorioCabecalhoWeb from '../Cabecalho/RelatorioCabecalhoWeb';
import RelatorioBoletimEletivaWeb from './RelatorioBoletimEletivaWeb';
import RelatorioBoletimProjetoWeb from './RelatorioBoletimProjetoWeb';
import { open } from "../../../../util/SimpleDialogMessage/actions/actions";
import SimpleDialogMessage from "../../../../util/SimpleDialogMessage/SimpleDialogMessage";
import { useDispatch } from 'react-redux';
import { findByTurma } from '../../../AlunoTurma/api-aluno-turma';
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardContent } from '@mui/material';


const useStyles = makeStyles({
    paper: {
        padding: '20px',
        backgroundColor: 'white',
    },
    title: {
        textAlign: 'center'
    },
    loading: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    voltarButton: {
        '@media print': {
            display: 'none'
        }
    }
});

export default function RelatorioBoletimItinerarioWeb() {
    const classes = useStyles();
    const [listaBE, setListaBE] = useState([]);
    const location = useLocation();
    const numeroBimestre = location.state.numeroBimestre;
    const [codAlunosTurmas, setCodAlunosTurmas] = useState(location.state.codAlunosTurmas);
    const codTurma = location.state.codTurma;
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState({
        title: '',
        description: ''
    });
    const dispatch = useDispatch();
    const progress = useRef(0);
    const history = useNavigate();


    useEffect(() => {
        if (codTurma) {
            findByTurma(codTurma).then((data) => {
                if (data.error) {
                    console.log(data);
                } else {
                    setCodAlunosTurmas(data.map((d) => d.codigo))
                }
            })
        }
    }, [codTurma]);

    useEffect(() => {
        if (codAlunosTurmas && codAlunosTurmas.length > 0) {
            async function asyncBoletimReport() {
                while (progress.current < codAlunosTurmas.length) {
                    await rltBoletimItinerarioWeb(numeroBimestre, codAlunosTurmas[progress.current]).then((data) => {
                        if (data.error) {
                            if (data.message === 'More than one turma') {
                                setMessage({
                                    title: 'Alerta',
                                    description: 'Aluno cadastrado em 2 turmas ou mais. O aluno só pode ser ativo em 1 turma.'
                                });
                                dispatch(open());


                            } else {
                                console.log(data);
                            }

                        } else {
                            setListaBE((prevState) => ([
                                ...prevState,
                                ...data
                            ]));

                        }
                        progress.current = progress.current + 1;
                    })
                }
                setIsLoading(false);

            }
            asyncBoletimReport();
        }



    }, [numeroBimestre, codAlunosTurmas, dispatch]);

    const handleGoBack = () => {
        history(-1);

    }


    return (
        <div>
            <SimpleDialogMessage title={message.title} description={message.description} />
            <Container className={classes.paper} component={Paper}>
                <Button
                    onClick={handleGoBack}
                    variant="contained"
                    color="secondary"
                    className={classes.voltarButton}
                >
                    <ArrowBackIcon style={{ marginRight: '10px' }} />
                    Voltar
                </Button>
                {listaBE.map((be, index) => (
                    <div key={index} style={{ marginTop: '20px', marginBottom: '100px' }}>
                        <Typography className={classes.title} variant="h5">
                            Boletim
                        </Typography>
                        <RelatorioCabecalhoWeb alunoTurma={be.alunoTurma} />
                        {be.bnotaBimestres && be.bnotaBimestres.length > 0 ? <RelatorioBoletimNotaBimestreWeb boletimEscolar={be} /> : ''}
                        <br />
                        {be.beletivas && be.beletivas.length > 0 ? <RelatorioBoletimEletivaWeb boletimEscolar={be} /> : ''}
                        <br />
                        {be.bprojetos && be.bprojetos.length > 0 ? <RelatorioBoletimProjetoWeb boletimEscolar={be} /> : ''}
                        <Card sx={{ width: '300px', margin: 2 }}>
                            <CardContent>
                                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                    Legenda
                                </Typography>
                                <Typography variant="body1" sx={{ fontSize: 12 }} component="div">
                                    A. C. - Ausência Compensada <br />
                                    Bim. - Bimestre <br />
                                    Con. Final - Conceito Final <br />
                                    C. H. - Carga Horária <br />
                                    Freq. - Frequência <br />
                                    Rec. Int. - Recuperação Intensiva <br />
                                    5º Con. - 5º Conceito <br />
                                </Typography>

                            </CardContent>
                        </Card >
                    </div>
                ))}
                {isLoading ?
                    <div className={classes.loading}>
                        <CircularProgress color="primary" /> Carregando...
                    </div> :
                    ''
                }







            </Container>

        </div>
    );
}